import { createStore } from "zustand-x"
import type { EntryDetail, EntrySummary } from "@/domain/entry/model/Entry"

/**
 * 신청 조회 상태.
 *
 * 연락처 + 비밀번호로 **목록**을 먼저 받고, 한 건을 고르면 상세를 받는 두 단계다.
 * 비밀번호는 상세 · 취소 · 수정에 다시 필요하므로 화면이 살아 있는 동안 들고 있는다.
 */
interface EntryLookupStoreState {
  gymContactPhoneNo: string
  password: string
  summaries: EntrySummary[]
  detail: EntryDetail | null
  /** 한 번이라도 조회를 시도했는지 — 첫 진입과 "결과 없음" 을 구분한다 */
  isSearched: boolean
  isLoading: boolean
  errorMessage: string
}

function makeInitEntryLookupState(): EntryLookupStoreState {
  return {
    gymContactPhoneNo: "",
    password: "",
    summaries: [],
    detail: null,
    isSearched: false,
    isLoading: false,
    errorMessage: "",
  }
}

const EntryLookupStore = createStore<EntryLookupStoreState>(
  makeInitEntryLookupState(),
  { name: "EntryLookupStore" },
)

export { EntryLookupStore, makeInitEntryLookupState }
export type { EntryLookupStoreState }
